// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__MfVge","messages":"Chat_messages__1EQfu","dateDivider":"Chat_dateDivider__1g8La"};